import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoutModel from './LogoutModel';
import { toast } from 'react-toastify';
import ReactTooltip from "react-tooltip";
import { Switch, useHistory, useLocation } from 'react-router-dom';
import { fncUndoCheckInPassengerApi, fncLoadFlightManifestDataForBoarding, fncGetTripStatus, fncBoardPassengers, fncUnBoardPassengers } from '../Utility/ApiCall.js';
import { flightManifestBoardingCredential, flightTripBoardingCredential, assistQueueCredential, moduleAndLoginDivDisabled } from '../ReduxState';
import { shortcutKeyForBoardingsPage, shortcutKeysBoarding, getSegmentsDetail, fncFocusElementDependsOnPathLocation } from '../Utility/CommonFun';
import "react-datepicker/dist/react-datepicker.css";
import onScan from '../../node_modules/onscan.js/onscan';
import * as moment from 'moment';
import '../Scss/_boarding.scss';
import FocusLock from "react-focus-lock";

function Boarding() {
    const boardingdiv=useRef(null);
    const  [boardingleftdivdisable,setboardingleftdivdisable]= useState(true);
    const notify = (e, close = 5000) =>
        toast.error(e, {
            position: "top-right",
            autoClose: close,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    const notifySuccess = (e, close = 5000) =>
        toast.success(e, {
            position: "top-right",
            autoClose: close,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
    const selectedLeg = useSelector(state => state.flightSearch.selectedFlight);
    const assistErrorQueue = useSelector(state => state.flightSearch.assistQueue);
    const IsModulAndLoginDivDisabled = useSelector(state => state.login.IsModulAndLoginDivDisabled);
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const Location = useSelector(state => state.login.Location);
    const [scannedPassenngerName, setscannedPassenngerName] = useState('');
    const [errorBoarding, seterrorBoarding] = useState('');
    const [scannedPassenngerSeat, setscannedPassenngerSeat] = useState('');
    const [scannedPassenngerSeq, setscannedPassenngerSeq] = useState('');
    const [scannedBoarding, setscannedBoarding] = useState(0);
    const [triggerModal, settriggerModal] = useState(false);
    // const [assistQueue, setAssistQueue] = useState([]);
    const [manualSeqInput, setmanualSeqInput] = useState('');

    useEffect(() => {

        if (!onScan.isAttachedTo(document)) {
            // console.log('===========-------===')
            onScan.attachTo(document, {
                onScan: function (sScancode, iQty) {
                    // console.log('a-aa-------------', sScancode);
                    if (sScancode !== '') {
                        // console.log('scanned string---------', sScancode);
                        const { origin, identifier } = flightManifest.market;
                        const carrier = process.env.REACT_APP_AirlineCode;
                        const forCarrier = sScancode.indexOf(carrier);
                        const flightno = sScancode.substring(forCarrier + 2, forCarrier + 6);
                        const forSeq = sScancode.indexOf(flightno);
                        const seq = sScancode.substring(forSeq + 12,forSeq + 16);
                        const forPnr = sScancode.indexOf(origin);
                        const PNR = sScancode.substring(forPnr - 6, forPnr);
                        // const seq = sScancode.substring(flightno + 2, flightno + 6);
                        // console.log('seq no========', parseInt(seq));
                        // console.log('scanned pnr', PNR);
                        const { passengerList } = flightManifest;
                        const scannedPassennger = passengerList.filter(p =>
                            p.recordLocator === PNR
                            && parseInt(seq) === getSegmentsDetail(flightManifest.market, 'boardingSequence', p));
                        // console.log('scannedPassennger', scannedPassennger);
                        if (scannedPassennger.length) {
                            const { passengerKey, recordLocator, name } = scannedPassennger[0];
                            const apiRequest = {
                                LegKey: selectedLeg,
                                Passengers: [{
                                    RecordLocator: recordLocator,
                                    PassengerKey: passengerKey
                                }]
                            }
                            fncBoardPassengers(apiRequest)
                                .then((returnVal) => {
                                    if (returnVal.status == "401" && returnVal.data == "") {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        settriggerModal(true);
                                    } else {
                                        // console.log('returnVal', returnVal);
                                        setscannedPassenngerName(`${name.last}, ${name.first} ${name.title ? name.title : ''}`);
                                        setscannedPassenngerSeat(getSegmentsDetail(flightManifest.market, 'seat', scannedPassennger[0]));
                                        setscannedPassenngerSeq(getSegmentsDetail(flightManifest.market, 'boardingSequence', scannedPassennger[0]));
                                        if (!returnVal.data.isError) {
                                            document.getElementById("showAndHideSpinner").style.display = "none";
                                            setscannedBoarding(1);

                                        } else {
                                            document.getElementById("showAndHideSpinner").style.display = "none";
                                            const errorQueue = [...assistErrorQueue];
                                            const currentPax = {
                                                scannedPassenngerName: `${name.last}, ${name.first} ${name.title ? name.title : ''}`,
                                                seqNumber: parseInt(seq),
                                                errorMessage: returnVal.data.errorDetail.errorMessage
                                            }
                                            if (errorQueue.filter(ass => ass.seqNumber === parseInt(seq)).length === 0) {
                                                errorQueue.push(currentPax);
                                                dispatch(assistQueueCredential(
                                                    {
                                                        type: "",
                                                        assistQueue: errorQueue,
                                                    }))
                                            }
                                            seterrorBoarding(returnVal.data.errorDetail.errorMessage);
                                            // setAssistQueue(errorQueue);
                                            setscannedBoarding(2);
                                        }
                                    }
                                })
                                .catch(e => console.log('Axios e in boarding passenger: ', e));
                        } else {
                            notify('Invalid boarding pass');
                        }
                    }
                }

            })
        }
        // Remove onScan.js from a DOM element completely on component unmount
        return () => {
            onScan.detachFrom(document);
        }
    }, []);

    // useEffect(() => {
    //     debugger
    //     const t = 'M1DEP/JHONNYLFFW4UDELBLRSG0143339Y014B0001147>1181O3339BSG00000000000002977500000000000';
    //     const test = 'M1BAHL/CHAHAT          E9FWRZ DELBOMSG 8709 255Y013E0004 147>1181 O3255BSG 000000000000029775shjsh27288 0                          ';
    //     const test2 = 'M1SINGH/AMITKUMAR      SBVNXG DELBOMSG 8709 256Y011C0012 147>1181 O3255BSG 0000000000000297750000000000 0                          ';
    //     // Simulate a scan programmatically - e.g. to test event handlers
    //     onScan.simulate(document, t);
    // }, []);

    useEffect(() => {
        if (selectedLeg && flightManifest) {
            document.addEventListener("keydown", shortcutKeyHandler);
        }

        // cleanup this listener
        return () => {
            document.removeEventListener('keydown', shortcutKeyHandler);
        };
    }, [selectedLeg, flightManifest]);

    const shortcutKeyHandler = (e) => {
        // debugger
        if (e.key && shortcutKeysBoarding.includes(e.key)) {
            const path = shortcutKeyForBoardingsPage(location.pathname, e);
            if (path) {
                history.push('/' + path);
            }
        }
    }

    const fncOnManualSeq = (e) => {
        // debugger
        const input = e.target.value;
        if (/^[0-9]+$/.test(input)) {
            if (input !== '' && input.length <= 5) {
                if (input === '00' || (input.length === 1 && input === '0')) {
                    setmanualSeqInput('');
                } else {
                    setmanualSeqInput(input);
                }
            } else {
                setmanualSeqInput('');
            }
        }
        else {
            setmanualSeqInput('');
        }
    }

    const searchBySeqNo = () => {
        const { passengerList } = flightManifest;
        const scannedPassennger = passengerList.filter(p => parseInt(manualSeqInput) === getSegmentsDetail(flightManifest.market, 'boardingSequence', p));
        if (scannedPassennger.length) {
            const { passengerKey, recordLocator, name } = scannedPassennger[0];
            const apiRequest = {
                LegKey: selectedLeg,
                Passengers: [{
                    RecordLocator: recordLocator,
                    PassengerKey: passengerKey
                }]
            }
            fncBoardPassengers(apiRequest)
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        settriggerModal(true);
                    } else {
                        setscannedPassenngerName(`${name.last}, ${name.first} ${name.title ? name.title : ''}`);
                        setscannedPassenngerSeat(getSegmentsDetail(flightManifest.market, 'seat', scannedPassennger[0]));
                        setscannedPassenngerSeq(getSegmentsDetail(flightManifest.market, 'boardingSequence', scannedPassennger[0]));
                        if (!returnVal.data.isError) {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            setscannedBoarding(1);

                        } else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            const errorQueue = [...assistErrorQueue];
                            const currentPax = {
                                scannedPassenngerName: `${name.last}, ${name.first} ${name.title ? name.title : ''}`,
                                seqNumber: parseInt(manualSeqInput),
                                errorMessage: returnVal.data.errorDetail.errorMessage
                            }
                            if (errorQueue.filter(ass => ass.seqNumber === parseInt(manualSeqInput)).length === 0) {
                                errorQueue.push(currentPax);
                                dispatch(assistQueueCredential(
                                    {
                                        type: "",
                                        assistQueue: errorQueue,
                                    }))
                            }
                            console.log(returnVal.data.errorDetail.errorMessage)
                            seterrorBoarding(returnVal.data.errorDetail.errorMessage);
                            // setAssistQueue(errorQueue);
                            setscannedBoarding(2);
                        }
                    }
                })
                .catch(e => console.log('Axios e in boarding passenger: ', e));
        } else {
            notify('Invalid boarding pass');
        }
        setmanualSeqInput('');
    }


    useEffect(() => {
        const handleFocusTrap = (event) => {
            if (event.key === "Tab") {
                event.preventDefault(); // Prevent default tab behavior
                const inputField = document.getElementById("inputselect");
                const boardButton = document.querySelector(".board1");    
                if (document.activeElement === inputField) {
                    if (!boardButton.disabled) {
                        boardButton.focus(); // Move focus to button if enabled
                    } 
                } else if (document.activeElement === boardButton) {
                    inputField.focus(); // Loop back to input if button is focused
                }
            }
        };
    
        const container = document.querySelector(".btn-container");
        container?.addEventListener("keydown", handleFocusTrap);
    
        return () => {
            container?.removeEventListener("keydown", handleFocusTrap);
        };
    }, []);
    

    useEffect((event) => {
        const handleKeyDown = (event) => {
            if (event.altKey && event.key.toLowerCase() === 'c') {
                                                if(!IsModulAndLoginDivDisabled){
                                                    dispatch(moduleAndLoginDivDisabled({
                                                        type: "MODULE_AND_LOGINDIV_DISABLED",
                                                        IsModulAndLoginDivDisabled: true
                                                    }));
                                                    fncFocusElementDependsOnPathLocation(location.pathname,document.getElementById("inputselect").current);
                                                }else if (IsModulAndLoginDivDisabled) {
                                                    // setdisableFocusOfPaymentcomponent(true);
                                                                                            const headingDiv = document.querySelector(".modulebtn");            
                                                                                            if (headingDiv) {                  
                                                                                                headingDiv.focus();
                                                                                                dispatch(moduleAndLoginDivDisabled({
                                                                                                        type: "MODULE_AND_LOGINDIV_DISABLED",
                                                                                                        IsModulAndLoginDivDisabled: false
                                                                                                    }));
                                                                                            }
                                                                                        }
                        }
            else if (event.shiftKey && event.key === "ArrowUp") {
                event.preventDefault(); // Prevent scrolling
                setboardingleftdivdisable(false);
                // setsearchFooterdisabled(true);
                // setflightsdivfocus(false);
                // setTableDisabled(true);
                boardingdiv.current?.focus(); // Move focus back to search input
                return;
            }
        else    if (event.shiftKey && event.key === "ArrowDown") {
                event.preventDefault(); 
                    setboardingleftdivdisable(true);
                    document.getElementById("inputselect").focus(); 
        //          else
        //          if (flightsdivfocus) {
        //             // If inside the table, move focus to the Load button in the footer
        //             // setflightsdivfocus(false);
        //             setTableDisabled(true);
        //             setsearchddisable(true);
        //             Loadref.current?.focus();
        //             setsearchFooterdisabled(false);
        //         }
        //     } 
          
        //  else   if (event.key === "ArrowDown") {
        //         newIndex = Math.min(selectedRow + 1, flights.length - 1);
        //         setSelectedRow(newIndex);
        //         tblrow.current[newIndex]?.focus(); // Ensure row focus
        //         selectRow(newIndex);
    
        //     } else if (event.key === "ArrowUp") {
        //         newIndex = Math.max(selectedRow - 1, 0);
        //         setSelectedRow(newIndex);
        //         tblrow.current[newIndex]?.focus(); // Ensure row focus
        //         selectRow(newIndex);
            }
    
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    },[boardingleftdivdisable, IsModulAndLoginDivDisabled])
    const handleKeyDown = (e) => {
        };
    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <div class="full-container">
                <div class="boarding-container fixedBtn">
                    <div class="row">
                        <div class="col-lg-6 mt-3">
                         <FocusLock disabled={boardingleftdivdisable}>  
                            <div class="card boarding-card OrangeShadow" tabIndex={-1} ref={boardingdiv}>
                                <div class="heading mb-3 OrangeShadow" >
                                    <h4 class="font-xxl bold dark-text mb-0">
                                        Boarding
                            </h4>
                                </div>
                                <p class="font-md semibold primary-text mb-0">Assist Queue({assistErrorQueue.length})</p>
                                {/* ({assistQueue.length}) */}
                                {
                                    assistErrorQueue.length === 0 ?
                                        <div class="boarding-card-content">
                                            <div class="boarding-small-card">
                                                <div class="boarding-small-heading px-3 py-2"></div>
                                                <div class="boarding-small-content p-3">
                                                    <p class="font-sm mb-2">No Issues</p>
                                                </div>
                                            </div>
                                        </div> :
                                        assistErrorQueue.map(item =>
                                            <div class="boarding-card-content">
                                                <div class="boarding-small-card">
                                                    <div class="boarding-small-heading px-3 py-2">
                                                        <p class="mb-0 bold font-sm">{item.scannedPassenngerName}</p>
                                                        <p class="mb-0 font-sm">Boarding Unsuccessful</p>
                                                    </div>
                                                    <div class="boarding-small-content p-3">
                                                        <p class="font-sm mb-2">{item.errorMessage}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                }
                            </div>
                            </FocusLock> 
                        </div>
                        <div class="col-lg-6 mt-3">
                            {
                                scannedBoarding === 1
                                    ?
                                    <div class="card boarding-card success-card">
                                        <div class="card-content">
                                            <div class="card-data">
                                                <p class="font-sm mb-2">Manual Board</p>
                                                <p class="font-lg mb-2 bold">{scannedPassenngerName}</p>
                                                <div class="d-flex">
                                                    <p class="font-lg mb-0 bold me-4">Seat<span class="ms-3">{scannedPassenngerSeat}</span></p>
                                                    <p class="font-md mb-0 me-4 semibold">Seq<span class="ms-3">#{scannedPassenngerSeq}</span></p>
                                                    <p class="font-md mb-0 me-4 semibold">Zone<span class="ms-3"></span></p>
                                                </div>
                                            </div>
                                            <div class="boarding-image">
                                                <img src="newImages/ticket-icon.svg" alt="ticket" />
                                            </div>
                                        </div>
                                        <div class="p-4">
                                            <p class="font-md success-text bold">Boarding Successful</p>

                                        </div>
                                    </div> : scannedBoarding === 2 ?
                                        <div class="card boarding-card  error-card">
                                            <div class="card-content">
                                                <div class="card-data">
                                                    <p class="font-sm mb-2">Manual Board</p>
                                                    <p class="font-lg mb-2 bold">{scannedPassenngerName}</p>
                                                    <div class="d-flex">
                                                        <p class="font-lg mb-0 bold me-4">Seat<span class="ms-3">{scannedPassenngerSeat}</span></p>
                                                        <p class="font-md mb-0 me-4 semibold">Seq<span class="ms-3">#{scannedPassenngerSeq}</span></p>
                                                        <p class="font-md mb-0 me-4 semibold">Zone<span class="ms-3"></span></p>
                                                    </div>
                                                </div>
                                                <div class="boarding-image">
                                                    <img src="newImages/ticket-icon.svg" alt="ticket" />
                                                </div>
                                            </div>
                                            <div class="p-4">

                                                <p class="font-md primary-text bold">Boarding Unsuccessful</p>
                                            </div>
                                        </div> : null
                            }


                        </div>
                    </div>

                    <div class="btn-container">
                        {/* <div> */}
                        {/* <label for="PNR">PNR:</label> */}
                        {/* <input type="text" id="pnr" name="PNR" /> */}
                        {/* </div> */}
                        <div class="manualBoard">
                            <img src="newImages/keybord-icon.svg" alt="keybord" />
                            <p class="font-md mb-0">Manual Board by Seq #:</p>
                            <input id='inputselect' type="text" class="form-control small-input OrangeShadow" onChange={(e) => { fncOnManualSeq(e) }} value={manualSeqInput} name="code" />
                        </div>
                        <button class="btn btn-primary SerachBtn board1" data-bs-toggle="modal" data-bs-target="#exampleModal"
                                                 //   onBlur={handlefocus} 
                          onClick={() => searchBySeqNo()} disabled={manualSeqInput === ''}
                        >
                            <span class="px-4">Board</span>
                        </button>
                    </div>
                    {/* {
                        errorBoarding !== '' ? */}
                    {/* <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog error-modal" >
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <img src="newImages/warning-icon.svg" alt="warning" />
                                            <h5 class=" mt-3 font-xxl bold">Boarding Unsuccessful</h5>
                                        </div>
                                        <div class="modal-body">
                                            <p class="font-lg pb-2">{errorBoarding}</p>
                                        </div>
                                        <div class="modal-footer-button">
                                            <button type="button" class="btn btn-white" data-bs-dismiss="modal"><span class="px-4">OK</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                    {/* //          : null
                    // }  */}

                </div>
            </div>
        </div>
    );
}

export default Boarding;